<template>
  <div v-if="!canceled" class="cross_sale container">
    <div class="cross_sale__banner w-100">
      <img :src="sale?.image" alt="Cross Sale" class="img-fluid" />
    </div>
    <div class="cross_sale__content my-2">
      <div class="cross_sale__products">
        <div class="desc-crosssell">{{ sale?.name }}</div>
        <ul>
          <li v-for="(product, index) in sale?.products" :key="index">
            {{ product.label }}
            <span v-if="index < sale?.products.length - 1" class="plus">+</span>
          </li>
        </ul>
        <div class="result">
          <p class="discount_price">{{ sale?.sell_price }}</p>
          <p class="original_price">{{ sale?.original_price }}</p>
        </div>
      </div>
    </div>
    <div class="cross_sale__actions mb-4">
      <button class="buy_button btn btn--primary" @click="addToOrder" aria-label="Buy"
        :class="isReqLoading ? 'loading disabled' : ''">
        اضف للطلب
      </button>
      <button class="cancel_button btn btn--primary" @click="cancelOrder" aria-label="Cancel">
        لا اريد العرض
      </button>
    </div>
  </div>
</template>


<script setup lang="ts">
import { ref } from "vue";
import { ElNotification } from "element-plus";
import crossSaleService from "@/services/crossSale";
import handleError from "@/helper/handleError";
import { useRouter } from "vue-router";
const router = useRouter();
// ====================== initialize data ========================

const canceled = ref(false);
const props = defineProps({
  sale: Object,
  orderID: String,
  productID: String,
});

const isReqLoading = ref(false);

// ========================== Methods ===================

// add cross sale to order
const addToOrder = () => {
  isReqLoading.value = true;
  const updatedCartData = {
    cross_sell_ids: props.sale?.id ? [props.sale.id] : [],
  };
  // here is if the payment method is online
  crossSaleService.updateOrderValue(props.orderID, updatedCartData, props.productID)
  .then((res: any) => {
      // On Thank You page, fire UPSELL PURCHASE custom event for the additional cross-sell
      let pixel_tracking = res.data.data.pixel_tracking;

      const script = document.createElement('script');
      let html = ``;
      const pixelTrackingData = {
        ...pixel_tracking,
        page_url: window.location.href
      };

      // Fire UPSELL PURCHASE custom event (not Purchase, since Purchase already fired for main product)
      html += `
        // For Facebook Pixel - Custom Event for Upsell Purchase
        if (typeof fbq !== "undefined") {
          fbq('trackCustom', 'UPSELL PURCHASE', ${JSON.stringify(pixelTrackingData)});
        }
      `;

      // Prepare TikTok pixel data with content_type adjustment
      const tiktokPixelData = { ...pixelTrackingData };
      if (tiktokPixelData.content_type && tiktokPixelData.content_type !== 'product') {
        tiktokPixelData.content_type = 'product_group';
      }

      html += `
        if (typeof ttq !== "undefined") {
          ttq.track('UPSELL PURCHASE', ${JSON.stringify(tiktokPixelData)});
        }
      `;
      script.innerHTML = html;
      document.head.appendChild(script);
    })
    .then(() => {
      ElNotification({
        title: "Success",
        message: "added to order",
        type: "success",
      });

      // Clear pixel tracking flag since order value has changed
      // This allows Purchase event to fire again on thank you page with updated total
      const trackingKey = `pixel_tracked_${props.orderID}`;
      localStorage.removeItem(trackingKey);

      canceled.value = true;
      if (router.currentRoute.value.path === '/pages/confirmation') {
        const currentQuery = {
          ...router.currentRoute.value.query,
          crossSaleAdded: 'true'
        };

        router.push({
          path: '/pages/thank',
          query: currentQuery
        });
      }

    }).catch((err: any) => {
      handleError(err);
    });
};

// Define the cancelOrder method
const cancelOrder = () => {
  canceled.value = true;

  if (router.currentRoute.value.path === '/pages/confirmation') {

    const currentQuery = {
      ...router.currentRoute.value.query,
    };

    router.push({
      path: '/pages/thank',
      query: currentQuery
    });

  }
};
</script>


<!-- style -->
<style lang="scss" scoped>
.desc-crosssell{
    font-size: 1.5rem;
    font-weight: 600;
    color: #6c6c6c;
    align-items: center;
}
.cross_sale {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #e3e8e8;
  border-radius: 10px;
  margin-bottom: 20px;

  .cross_sale__banner {
    img {
      /*
     //border-top-left-radius: 10px;
     //border-top-right-radius: 10px;
      */
      width: 100%;
      height: auto;
      max-height: 500px;
      /* Replace with the maximum height you want */
      object-fit: cover;
      /* This will ensure that the image covers the full width and height of its container without stretching */
    }
  }

  .cross_sale__banner {
    width: 660px !important;
    //height: 200px !important;
  }

  .cross_sale__content {
    width: 100%;

    .cross_sale__products {
      ul {
        margin: 14px 0;
        padding: 0;
        list-style: none;
        display: flex;
        justify-content: center;
        align-items: center;
        /* gap: 15px; */
        width: 100%;
        line-height: 24px;
        flex-wrap: wrap;

        li {
          font-size: 1.5rem;
          font-weight: 600;
          color: #6c6c6c;
          display: flex;
          align-items: center;

          .plus {
            font-size: 1.5rem;
            font-weight: 600;
            color: #6c6c6c;
            width: 40px;
            display: inline-block;
            text-align: center;
          }
        }
      }

      .result {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
        /* margin-bottom: 10px; */
        /* margin-top: 20px;*/

        p {
          margin: 0;
        }

        .discount_price {
          font-size: 30px;
          font-weight: 600;
          color: #1a0058;
          text-decoration: auto;
        }

        .original_price {
          font-size: 24px;
          font-weight: 600;
          color: #6c6c6c;
          text-decoration: line-through;
        }
      }
    }

    p {
      font-size: 1.2rem;
      text-align: center;
    }
  }

  .cross_sale__actions {
    display: flex;
    justify-content: space-between;
    display: flex;
    justify-content: center;
    align-content: center;
    gap: 10px;

    .buy_button {
      background-color: #2177f6;
    }

    .cancel_button {
      background: #fa4040;
    }

    button {
      // width: 100%;
      /* margin: 10px 0; */
      padding: 11px 70px;
      border-radius: 8px;
      color: #fff;
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
    }
  }
}


@media (min-width: 320px) and (max-width: 374.98px) {
  .cross_sale {
    padding: 0px !important;

    .cross_sale__banner {
      height: auto !important;
      width: 100% !important;

      img {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        width: 100%;
        height: auto;
        max-height: 500px;
        /* Replace with the maximum height you want */
        object-fit: cover;
        /* This will ensure that the image covers the full width and height of its container without stretching */
      }
    }

    .cross_sale__content {

      .cross_sale__products {
        ul {
          padding: 0;
          list-style: none;
          display: flex;
          justify-content: center;
          gap: 0px;
          width: 100%;
          line-height: 20px;
          flex-wrap: wrap;


          li {
            font-weight: 600;
            align-items: center;
            display: contents;

            .plus {
              font-size: 1.5rem;
              font-weight: 600;
              color: #6c6c6c;
              width: 40px;
              display: flow-root;
              text-align: center;
            }
          }
        }

        .result {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
          flex-direction: row;

          p {
            margin: 0;
          }

          .discount_price {
            font-size: 1.2rem;
            font-weight: 600;
            color: #1a0058;
            text-decoration: auto;
          }

          .original_price {
            font-size: 1.2rem;
            font-weight: 600;
            color: #6c6c6c;
            text-decoration: line-through;
          }
        }
      }

      p {
        font-size: 1.2rem;
        text-align: center;
      }
    }

    .cross_sale__actions {
      display: flex;
      justify-content: space-between;
      display: flex;
      justify-content: center;
      align-content: center;
      gap: 10px;

      .buy_button {
        background-color: #2177f6;
      }

      .cancel_button {
        background: #fa4040;
      }

      button {
        margin: 10px 0;
        padding: 8px 20px;
        border-radius: 8px;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }
}



@media (min-width: 375px) and (max-width: 424.98px) {
  .cross_sale {
    padding: 0px !important;

    .cross_sale__banner {
      height: auto !important;
      width: 100% !important;

      img {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        width: 100%;
        height: auto;
        max-height: 500px;
        /* Replace with the maximum height you want */
        object-fit: cover;
        /* This will ensure that the image covers the full width and height of its container without stretching */
      }
    }

    .cross_sale__content {

      .cross_sale__products {
        ul {
          padding: 0;
          list-style: none;
          display: flex;
          justify-content: center;
          gap: 0px;
          width: 100%;
          line-height: 20px;
          flex-wrap: wrap;


          li {
            font-weight: 600;
            align-items: center;
            display: contents;

            .plus {
              font-size: 1.5rem;
              font-weight: 600;
              color: #6c6c6c;
              width: 40px;
              display: flow-root;
              text-align: center;
            }
          }
        }

        .result {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
          flex-direction: row;

          p {
            margin: 0;
          }

          .discount_price {
            font-size: 1.5rem;
            font-weight: 600;
            color: #1a0058;
            text-decoration: auto;
          }

          .original_price {
            font-size: 1.3rem;
            font-weight: 600;
            color: #6c6c6c;
            text-decoration: line-through;
          }
        }
      }

      p {
        font-size: 1.2rem;
        text-align: center;
      }
    }

    .cross_sale__actions {
      display: flex;
      justify-content: space-between;
      display: flex;
      justify-content: center;
      align-content: center;
      gap: 10px;

      .buy_button {
        background-color: #2177f6;
      }

      .cancel_button {
        background: #fa4040;
      }

      button {
        margin: 10px 0;
        padding: 11px 30px;
        border-radius: 8px;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }
}



@media (min-width: 425px) and (max-width: 575.98px) {
  .cross_sale {
    padding: 0px !important;

    .cross_sale__banner {
      height: auto !important;
      width: 100% !important;

      img {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        width: 100%;
        height: auto;
        max-height: 500px;
        /* Replace with the maximum height you want */
        object-fit: cover;
        /* This will ensure that the image covers the full width and height of its container without stretching */
      }
    }

    .cross_sale__content {

      .cross_sale__products {
        ul {
          padding: 0;
          list-style: none;
          display: flex;
          justify-content: center;
          gap: 0px;
          width: 100%;
          line-height: 20px;
          flex-wrap: wrap;


          li {
            font-weight: 600;
            align-items: center;
            display: contents;

            .plus {
              font-size: 1.5rem;
              font-weight: 600;
              color: #6c6c6c;
              width: 40px;
              display: flow-root;
              text-align: center;
            }
          }
        }

        .result {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
          flex-direction: row;

          p {
            margin: 0;
          }

          .discount_price {
            font-size: 1.6rem;
            font-weight: 600;
            color: #1a0058;
            text-decoration: auto;
          }

          .original_price {
            font-size: 1.4rem;
            font-weight: 600;
            color: #6c6c6c;
            text-decoration: line-through;
          }
        }
      }

      p {
        font-size: 1.2rem;
        text-align: center;
      }
    }

    .cross_sale__actions {
      display: flex;
      justify-content: space-between;
      display: flex;
      justify-content: center;
      align-content: center;
      gap: 10px;

      .buy_button {
        background-color: #2177f6;
      }

      .cancel_button {
        background: #fa4040;
      }

      button {
        margin: 10px 0;
        padding: 13px 45px;
        border-radius: 8px;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .cross_sale {
    padding: 0px !important;

    .cross_sale__banner {
      height: auto !important;
      width: 100% !important;

      img {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        width: 100%;
        height: auto;
        max-height: 500px;
        /* Replace with the maximum height you want */
        object-fit: cover;
        /* This will ensure that the image covers the full width and height of its container without stretching */
      }
    }

    .cross_sale__content {

      .cross_sale__products {
        ul {
          padding: 0;
          list-style: none;
          display: flex;
          justify-content: center;
          gap: 0px;
          width: 100%;
          line-height: 20px;
          flex-wrap: wrap;


          li {
            font-weight: 600;
            align-items: center;
            display: contents;

            .plus {
              font-size: 1.5rem;
              font-weight: 600;
              color: #6c6c6c;
              width: 40px;
              display: flow-root;
              text-align: center;
            }
          }
        }

        .result {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
          flex-direction: row;

          p {
            margin: 0;
          }

          .discount_price {
            font-size: 1.6rem;
            font-weight: 600;
            color: #1a0058;
            text-decoration: auto;
          }

          .original_price {
            font-size: 1.4rem;
            font-weight: 600;
            color: #6c6c6c;
            text-decoration: line-through;
          }
        }
      }

      p {
        font-size: 1.2rem;
        text-align: center;
      }
    }

    .cross_sale__actions {
      display: flex;
      justify-content: space-between;
      display: flex;
      justify-content: center;
      align-content: center;
      gap: 10px;

      .buy_button {
        background-color: #2177f6;
      }

      .cancel_button {
        background: #fa4040;
      }

      button {
        margin: 10px 0;
        /*padding: 13px 45px;*/
        border-radius: 8px;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }
}



@media (min-width: 768px) and (max-width: 991.98px) {
  .cross_sale {
    padding: 0px !important;

    .cross_sale__banner {
      height: auto !important;
      width: 100% !important;

      img {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        width: 100%;
        height: auto;
        max-height: 500px;
        /* Replace with the maximum height you want */
        object-fit: cover;
        /* This will ensure that the image covers the full width and height of its container without stretching */
      }
    }

    .cross_sale__content {

      .cross_sale__products {
        ul {
          padding: 0;
          list-style: none;
          display: flex;
          justify-content: center;
          gap: 0px;
          width: 100%;
          line-height: 20px;
          flex-wrap: wrap;


          li {
            font-weight: 600;
            align-items: center;
            display: contents;

            .plus {
              font-size: 1.5rem;
              font-weight: 600;
              color: #6c6c6c;
              width: 40px;
              display: flow-root;
              text-align: center;
            }
          }
        }

        .result {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
          flex-direction: row;

          p {
            margin: 0;
          }

          .discount_price {
            font-size: 1.6rem;
            font-weight: 600;
            color: #1a0058;
            text-decoration: auto;
          }

          .original_price {
            font-size: 1.4rem;
            font-weight: 600;
            color: #6c6c6c;
            text-decoration: line-through;
          }
        }
      }

      p {
        font-size: 1.2rem;
        text-align: center;
      }
    }

    .cross_sale__actions {
      display: flex;
      justify-content: space-between;
      display: flex;
      justify-content: center;
      align-content: center;
      gap: 10px;

      .buy_button {
        background-color: #2177f6;
      }

      .cancel_button {
        background: #fa4040;
      }

      button {
        margin: 10px 0;
        /*padding: 13px 45px;*/
        border-radius: 8px;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }
}

@media (max-width: 768px) {
  .cross_sale {
    padding: 10px;
  }

  .cross_sale__products ul {
    flex-direction: column;
    align-items: center;
  }

  .cross_sale__banner {
    height: auto;

    img {
      max-height: 200px;
    }
  }

  .result {
    flex-direction: column;
    gap: 5px;
  }

  .discount_price {
    font-size: 1.5rem;
  }

  .original_price {
    font-size: 1rem;
  }
}
</style>
